import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'iterables'
})
export class KeysPipe implements PipeTransform {
    transform(value, args: string[]): any {
        if (!value) {
            return value;
        }

        let keys = [];
        for (let key in value) {
            if (value.hasOwnProperty(key)) {
                keys.push({key: key, value: value[key]});
            }
        }
        return keys;
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/iterables.pipe.ts